import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import tireAvif from './assets/tire.avif';
import tirePng from './assets/tire.png';
import tireWebp from './assets/tire.webp';

export function TireUpSellCard() {
  return (
    <div className='flex flex-col gap-2 md:gap-4'>
      <h2 className='text-xl font-bold text-primary md:text-3xl'>
        <Trans>Do you need new tires?</Trans>
      </h2>
      <NoddiBasicCard
        to={customerRoutes.requestTireOffer.getPath()}
        className='relative w-full max-w-2xl overflow-hidden p-0'
      >
        <picture className='block aspect-[4/3] w-full'>
          <source srcSet={tireAvif} type='image/avif' />
          <source srcSet={tireWebp} type='image/webp' />
          <img src={tirePng} alt='Continental Tire' className='size-full object-cover' />
        </picture>

        <div
          className='absolute inset-0'
          style={{
            background:
              'linear-gradient(to bottom, transparent 0%, transparent 20%, rgba(0,0,0,0.3) 35%, rgba(0,0,0,0.85) 55%, rgba(0,0,0,0.95) 100%)'
          }}
        />

        <div className='absolute inset-x-0 bottom-0 p-5 md:p-6'>
          <div className='flex flex-col gap-3'>
            <div>
              <NoddiDummyButton className='w-full'>
                <Trans>Request an offer</Trans>
              </NoddiDummyButton>

              <p className='mt-4 text-center text-xs text-gray-300'>
                <Trans>Mounting included • We come to you • 100% Customization guarantee</Trans>
              </p>
            </div>
          </div>
        </div>
      </NoddiBasicCard>
    </div>
  );
}
